import React, { useEffect, useMemo, useRef, useState } from "react";
import config from "../../../config";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import SearchMenu from "./SearchMenu";
import OutsideClick from "../../common/OutsideClick";
import { debouncedSuggestedSearches } from "../../actionCreators/boostCommerceAC";
import { useDispatch } from "react-redux";
import { isSearchUrl } from "../../common/utils";
import { CleanCrossIcon, SearchIconThin } from "../../common/Icons";
import Button from "react-bootstrap/Button";
import _ from "underscore";
import { setRecentSearch } from "../helpers";
import { noScroll } from "../../actionCreators/appAC";

const SearchBar = React.memo((props) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [inputFocused, setInputFocused] = useState(false);
    const [escPressed, setEscPressed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const { mobile, top_promo_banner_not_visible, closeMobileSearch } = props;
    const dispatch = useDispatch();
    const searchBarRef = useRef();

    // useEffect(() => {
    //     if (isSearchUrl()) {
    //         const urlParams = new URLSearchParams(window.location.search);
    //         const q = urlParams.get("q");
    //         setSearchQuery(q);
    //     }
    // }, []);

    useEffect(() => {
        let isApiSubscribed = true;
        dispatch(debouncedSuggestedSearches(isApiSubscribed, searchQuery, setIsLoading));
        setIsTyping(true);
        debounceSearchTyping();
        if (searchQuery && !inputFocused && escPressed) {
            setInputFocused(true);
            setEscPressed(false);
        }
        return () => {
            isApiSubscribed = false;
        };
    }, [searchQuery]);

    const debounceSearchTyping = useMemo(() => {
        return _.debounce(() => {
            setIsTyping(false);
        }, config.searchDebounceValue);
    }, []);

    const handleOutsideClick = () => {
        if (mobile) {
            closeMobileSearch();
        }
        setInputFocused(false);
    };

    const handleFocusClick = () => {
        if (mobile) {
            dispatch(noScroll(true));
        }
        setInputFocused(true);
    };

    const handleSearchSubmit = () => {
        if (searchQuery) setRecentSearch(searchQuery);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            setSearchQuery("");
            setInputFocused(false);
            setEscPressed(true);
        }
    }

    return (
        <>
            <OutsideClick callbackAction={handleOutsideClick} customClass="search-bar">
                <Form
                    inline
                    action={`${config.host_rebag_shop}/search`}
                    ref={searchBarRef}
                    className="search-bar__form"
                    onSubmit={() => handleSearchSubmit()}
                >
                    <InputGroup>
                        <div className="search-bar__form-input-parent">
                            <FormControl
                                id="search-menu-input"
                                className="search-bar__form-input"
                                placeholder='Try searching "Chanel" or "Black Tote"'
                                aria-label="Search"
                                name="q"
                                autoFocus={!!mobile}
                                autoComplete="off"
                                value={searchQuery || ""}
                                onKeyDown={handleKeyDown}
                                onClick={() => handleFocusClick()}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onFocus={() => handleFocusClick()}
                            />
                            {searchQuery &&
                                <Button
                                    className="search-bar__form-clear-button"
                                    variant="clean"
                                    onClick={(e) => setSearchQuery("")}
                                >
                                    <CleanCrossIcon
                                        style={{ width: 20 }}
                                        label="Clear"
                                        stroke="#767676"
                                    />
                                </Button>
                            }
                        </div>
                        {mobile &&
                            <Button
                                className="search-bar__form-cancel-button"
                                variant="clean"
                                onClick={handleOutsideClick}
                            >
                                Cancel
                            </Button>
                        }
                    </InputGroup>
                    {!mobile &&
                        <label
                            htmlFor="search-menu-input"
                            className="search-bar__icon"
                        >
                            <SearchIconThin
                                style={{ width: 22 }}
                                color="#000000"
                                label="Search"
                            />
                        </label>
                    }
                </Form>
                <SearchMenu
                    mobile={mobile}
                    inputFocused={inputFocused}
                    top_promo_banner_not_visible={top_promo_banner_not_visible}
                    searchBarRef={searchBarRef}
                    searchQuery={searchQuery}
                    handleOutsideClick={handleOutsideClick}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    isTyping={isTyping}
                />
            </OutsideClick>
            {inputFocused && !mobile && <div className="fade modal-backdrop dark-overlay dark-overlay--search show"></div>}
        </>
    );
});

export default SearchBar;